import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';

import { Button, Layout, Table, Form, Input } from 'antd';
import type { TableProps } from 'antd';
import { PageHeader } from '@ant-design/pro-components';

import { DateUpdateFlexRow } from '../../components/widgets/DateUpdateFlexRow';
import { Customer } from '../../hooks/data/models';
import { useCustomers } from '../../hooks/data/useCustomers';

const columns: TableProps<Customer>['columns'] = [
  {
    title: 'Name',
    dataIndex: 'name',
    key: 'name',
    render: (text: any, record) => (
      <span>
        {record.firstName} {record.lastName}
      </span>
    ),
  },
  {
    title: 'Email',
    dataIndex: 'email',
    key: 'email',
    filterSearch: (input, record) => record.text ? record.text.toString().includes(input) : false
  },
  {
    title: 'Created',
    dataIndex: 'createdAt',
    key: 'created',
    render: (date: string) => (<span>{date.substring(0, 10)}</span>)
  },
  {
    title: 'Action',
    key: 'action',
    render: (_, record) => (
      <Link to={`/customers/${record._id}`}>
          Edit
      </Link>
    )
  },
];

export const CustomerListPage = () => {
  
  const navigate = useNavigate();

  //Form to filter customers
  const [filterForm] = Form.useForm();
  const [filterParams, setFilterParams] = useState({
    firstName: '',
    lastName: '',
    email: '',
  });

  //Customer data hook
  const { customers, isLoading, lastUpdated, refreshMainList } = useCustomers(filterParams);
  const formatDate = (date: number) => {
    return new Intl.DateTimeFormat('en-GB', {
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false,
    }).format(date);
  };

  // Function to handle form submission (onFinish in antd form implementation)
  const onFinishFilter = (values: { firstName?: string; lastName?: string; email?: string }) => {
    // Update the state, which will re-trigger the useMemo and then useSWR
    setFilterParams({
      firstName: values.firstName || '',
      lastName: values.lastName || '',
      email: values.email || '',
    });
  };

  // Function to handle form reset
  const onResetFilter = () => {
    filterForm.resetFields();
    setFilterParams({ firstName: '', lastName: '', email: '' });
  };

  return (
    <Layout.Content>
      <PageHeader
        title="Customers"
        extra={
            <Button
              onClick={() => navigate('/customers/create')}
              title={'new customer'}
              type={'primary'}>
              new customer
            </Button>
        }
      />

      <Form layout='inline' form={filterForm} onFinish={onFinishFilter} style={{marginBottom: '6px'}}>
        <Form.Item name="firstName">
          <Input placeholder="first name" />
        </Form.Item>
        <Form.Item name="lastName">
          <Input placeholder="family name" />
        </Form.Item>
        <Form.Item name="email">
          <Input placeholder="email" />
        </Form.Item>
        <Form.Item>
          <Button type="default" htmlType="button" onClick={onResetFilter}>Reset</Button>
        </Form.Item>
        <Form.Item>
          <Button type="default" htmlType="submit">Search</Button>
        </Form.Item>
      </Form>

      {/* TODO: show errors here */}
      <DateUpdateFlexRow 
        lastUpdated={lastUpdated}
        refreshCallback={refreshMainList}
      />

      <Table
        columns={columns}
        dataSource={customers}
        loading={isLoading}
        rowKey={"_id"}
      />
    </Layout.Content>
  );
};
